module.exports = __webpack_public_path__ + "img/bar_03.93da77b3.webp";